import { Box, Text } from "grommet";
import { Spinner } from "components";
import { BudgetUtilization } from "components/Dashboard/BudgetUtilization/BudgetUtilization";
import { BudgetUtilizationTrend } from "components/Dashboard/BudgetUtilization/BudgetUtilizationTrend";
import { DashboardCard } from "components/Dashboard/DashboardCard";
import { Workload } from "components/Dashboard/Workload/Workload";
import { WorkloadTrend } from "components/Dashboard/Workload/WorkloadTrend";
import { getColorByBudgetUtilization } from "helpers/dashboard";
import { ProjectWithMetrics } from "pages/Dashboard";
import { MetricWrapper } from "./MetricWrapper";

type Props = {
  projectMetrics: ProjectWithMetrics[];
  loading?: boolean;
};
export const SLA = ({ projectMetrics, loading }: Props) => {
  return (
    <Box>
      <Text size={"medium"} margin={{ vertical: "medium" }}>
        SLA
      </Text>
      {loading && <Spinner />}
      {projectMetrics &&
        projectMetrics.map((project) => (
          <DashboardCard
            key={project.id}
            label={project.name}
            margin={{ bottom: "small" }}
            color={getColorByBudgetUtilization(
              project.budgetUtilization?.spent,
              project.budgetUtilization?.min,
              project.budgetUtilization?.max
            )}
          >
            <MetricWrapper label={"Workload"}>
              <Workload fte={project.workload?.index} deviation={project.workload?.percentageChange} />
            </MetricWrapper>
            <MetricWrapper label={"Workload Trend"} width={"medium"}>
              <WorkloadTrend data={project.workload?.trend} />
            </MetricWrapper>
            {(project.budgetUtilization?.min || project.budgetUtilization?.max) && (
              <MetricWrapper label={"Budget Utilization"} width={"medium"}>
                <BudgetUtilization
                  spent={project.budgetUtilization?.spent ?? 0}
                  min={project.budgetUtilization?.min}
                  max={project.budgetUtilization?.max}
                />
              </MetricWrapper>
            )}
            <MetricWrapper label={"Budget Utilization Trend"} width={"medium"}>
              <BudgetUtilizationTrend
                data={project.budgetUtilization?.trend}
                min={project.budgetUtilization?.min}
                max={project.budgetUtilization?.max}
              />
            </MetricWrapper>
          </DashboardCard>
        ))}
    </Box>
  );
};
